import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { IoClose } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { API } from '../config';


export default function ChangePassword({ show, onClose, token }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (show) {
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        }
    }, [show]);

    if (!show) return null;

  const handleSubmit = async e => {
    e.preventDefault();
    if (!currentPassword || !newPassword || !confirmPassword) {
      return toast.error('Please fill out all fields.');
    }
    if (newPassword !== confirmPassword) {
      return toast.error('New passwords do not match.');
    }
    if (newPassword.length < 4) {
      return toast.error('New password must be at least 4 characters.');
    }

    setSubmitting(true);
    try {
      await axios.patch(
        `${API}/api/users/me/password`,
        { currentPassword, newPassword, confirmPassword },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Password changed!');
      onClose();
      // clear fields
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Could not change password.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className='change-password'>
        <div className="overlay">
              <form onSubmit={handleSubmit} className="pwd-form">
                <IoClose className="close-icon" onClick={onClose}/>
                <div className="form-input">
                      <label htmlFor="currentPassword">
                          Enter your current password
                      </label>
                      <input
                        name='currentPassword'
                        type="password"
                        value={currentPassword}
                        onChange={e => setCurrentPassword(e.target.value)}
                        required
                      />
                </div>
                <div className="form-input">
                      <label htmlFor="newPassword">
                          Enter your new password
                      </label>
                      <input
                        name='newPassword'
                        type="password"
                        value={newPassword}
                        onChange={e => setNewPassword(e.target.value)}
                        required
                        minLength={4}
                      />
                </div>
                <div className="form-input">
                      <label htmlFor="confirmPassword">
                          Confirm your new password
                      </label>
                      <input
                        name='confirmPassword'
                        type="password"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        required
                        minLength={4}
                      />
                </div>

                <button type="submit" className="btn" id='feedback-button' disabled={submitting}>
                    <span className="btn-text">{submitting ? 'Saving…' : 'Save'}</span>
                </button>
              </form>
        </div>
    </section>

  );
}
